<span class="tag tag-s-{{isActive ? sectorHelper.getSectorColor(sector) : ''}} mb-5">
  <span>{{ sector }}</span>
</span>
